module.exports = __webpack_public_path__ + "static/img/image8.31ce80c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/image8.png
// module id = Yvnu
// module chunks = 14